import { render, staticRenderFns } from "./MyPeoplesWebpart.vue?vue&type=template&id=d8dc15f0"
import script from "./MyPeoplesWebpart.ts?vue&type=script&lang=ts&external"
export * from "./MyPeoplesWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports